(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-carousel')) {
    customElements.define(
      'hero-carousel',
      class HeroCarousel extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.getAttribute('data-section-id');
        }

        connectedCallback() {
          this.swiperEl = this.querySelector('swiper-container');
          if (Shopify.designMode && this.swiperEl) {
            document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
          }
        }

        onBlockSelect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          const targetSlide = this.querySelector(`#${event.detail.sectionId}-${event.detail.blockId}`);
          const targetIndex = parseInt(targetSlide.getAttribute('data-index'));
          this.swiperEl.swiper.slideTo(targetIndex, 0);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this), { once: true });
        }

        onBlockDeselect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          this.swiperEl.swiper.slideTo(0, 0);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('social-feed')) {
    customElements.define(
      'social-feed',
      class SocialFeed extends HTMLElement {
        constructor() {
          super();
          this.observer = null;
          this.feedChildrenCount = 0;
        }

        connectedCallback() {
          const instaFeed = this.querySelector('#insta-feed');
          if (!instaFeed) return;

          this.observer = new MutationObserver((mutationsList) => {
            // console.log('Insta feed mutated', mutationsList[0]);
            const addedNodes = mutationsList[0].addedNodes;
            const container = Array.from(addedNodes)
              .filter((node) => node.tagName === 'DIV')[0]
              .querySelector('.instafeed-new-layout-wrapper');
            // console.log('Container:', container);
            this.setupMarquee(container);
            this.dispatchEvent(new CustomEvent('insta-feed:mutated', { detail: mutationsList }));
            this.observer.disconnect();
          });

          this.observer.observe(instaFeed, {
            childList: true,
            subtree: false,
          });
        }

        setupMarquee(container) {
          if (!container) return;

          const children = Array.from(container.children);
          if (children.length === 0) return;

          children.forEach((child) => {
            const imgs = child.querySelectorAll('img[data-instafeed-src]');
            imgs.forEach((img) => {
              if (img.dataset.instafeedSrc) {
                img.src = img.dataset.instafeedSrc;
              }
            });
          });

          container.innerHTML = '';

          for (let i = 0; i < 2; i++) {
            const track = document.createElement('div');
            track.className = 'instafeed-marquee__track';
            const wrapper = document.createElement('div');
            wrapper.className = 'instafeed-marquee__wrapper';
            const flex = document.createElement('div');
            flex.className = 'instafeed-marquee__flex';

            children.forEach((child) => flex.appendChild(child.cloneNode(true)));

            wrapper.appendChild(flex);
            track.appendChild(wrapper);
            container.appendChild(track);
          }
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
